import * as Yup from "yup";

const grupoProdutosTributarioXmlValidator = Yup.object().shape({
  grupoProdutoId: Yup.number().required("Grupo de Produto"),
  grupoTributacaoId: Yup.number().required("Grupo tributário"),
  cfopId: Yup.number().nullable(),
  unidadeComercialVendaId: Yup.number().nullable(),
});

export default grupoProdutosTributarioXmlValidator;
